<section id="AboutUs" class="section projects-section">
  <div class="container">

    <div class="projects-header">
      <h2 class="section-heading">
        {{'GB_Registration_AboutTheCartel' | translate}}
      </h2>
    </div>

    <div class="projects-grid">
      @for(item of projects; track item; let i = $index) {
        <a class="project-card"
           [routerLink]="['/pages/projects/' + item.url]"
           [matTooltip]="item.title | translate">

          <img [src]="item.img" [alt]="item.title | translate" class="card-img" />

          <div class="card-overlay">
            <span class="card-number">{{ (i + 1) | number: '2.0' }}</span>
            <div class="card-content">
              <h3 class="card-title">{{ item.title | translate }}</h3>
              <span class="card-cta">
                {{'GB_Registration_LearnMore' | translate}}
                <i class="fa-solid fa-arrow-right"></i>
              </span>
            </div>
          </div>

        </a>
      }
    </div>

  </div>
</section>
